import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

import useEmployee from "hooks/useEmployee";
import { useLanguageOptions } from "hooks/useLanguageOptions";

import { getHeaderConfig } from "./utils";

import Logo from "../../assets/GrECo_Logo_small.jpg";
import useNotificationHandler from "../../hooks/useNotificationHandler";
import i18n from "../../i18n";
import { STORAGE_KEYS } from "../../library/shared";
import { SelectItem } from "../../library/types";
import { saveToLocalStorage } from "../../library/utils";
import { panelIsOpenState } from "../../store";
import { buildYupLocale } from "../../validation";
import GrecoHeader from "../GrecoHeader/GrecoHeader";

const AppHeader = () => {
  const { t } = useTranslation();
  const { notifications, handleClearAllNotifications } = useNotificationHandler();
  const { employeeData } = useEmployee();

  const setPanelIsOpen = useSetAtom(panelIsOpenState);

  const headerConfig = getHeaderConfig(t("hbh.appNameHeader.label"));

  const languageOption = useLanguageOptions();

  return (
    <GrecoHeader
      headerConfig={headerConfig}
      panelStatus={setPanelIsOpen}
      user={employeeData}
      notifications={notifications}
      clearNotifications={handleClearAllNotifications}
      logo={Logo}
      languageOptions={languageOption}
      defaultLanguage={i18n.language}
      onChangeLanguage={async (__event: any, languageOption?: SelectItem) => {
        if (!languageOption) return;
        saveToLocalStorage(STORAGE_KEYS.appLang, languageOption?.value || "");

        i18n.changeLanguage(languageOption.value as string);
        buildYupLocale();
      }}
      headerStrings={{
        notificationsPanelStrings: {
          panelTitle: t("header.Notifications"),
          noNotificationsTitle: t("header.NoNotificationsTitle"),
          noNotificationsSubtitle: t("header.NoNotificationsSubtitle"),
        },
        settingsPanelStrings: {
          panelTitle: t("header.Settings"),
          darkModeToggleLabel: t("header.DarkMode"),
          selectLanguageLabel: t("header.SelectLanguage"),
        },
      }}
    />
  );
};

export default AppHeader;
